<template>
    <div>
        <mini-step class="f-topic-official-more-issue-show"
            :info="OfficialBoardLabel.RelatedIssue">
            <span slot="text"
                v-if="issuelist.length"
                class="f-topic-official-more-issue-list">
                <ul :class="isShowMoreIssue ? 'f-topic-official-more-list-more' :'f-topic-official-more-list'">
                    <li v-for="item in issuelist"
                        :key="item.issueId"
                        class="f-topic-official-more-list-item">
                        <router-link target="_blank" :title="item.title"
                            :to="{name: 'issueContent', params: {issueid: item.issueId}}">
                            <span class="f-topic-official-more-list-item-id">
                                #{{item.issueId}}
                            </span>
                            <span class="f-topic-official-more-list-item-title">
                                {{item.title}}
                            </span>
                            <span class="f-topic-official-more-list-item-process">
                                {{item.process | matchIssueProcess}}
                            </span>
                        </router-link>
                    </li>
                </ul>
                <span v-if="issuelist.length > 3"
                    class="f-topic-official-more-list-moreTip"
                    @click="toggleShowMoreIssue">
                    <span v-if="!isShowMoreIssue">
                        <span>显示更多</span>
                        <span class="fa fa-caret-down"></span>
                    </span>
                    <span v-else>
                        <span>收起</span>
                        <span class="fa fa-caret-up"></span>
                    </span>
                </span>
            </span>
            <span v-else slot="text"
                class="f-topic-official-more-issue-empty">无</span>
        </mini-step>

        <div class="f-topic-official-more-issue-setting">
            <veui-checkbox
                v-if="relatedIssueType === 'official'
                    && canOperateOfficial"
                class="f-topic-official-more-issue-check"
                v-model="checkedNotRelatedIssue"
                ui="small"
                :readonly="isAuditPending"
                @change="toggleCheck"
                >
                不设置
            </veui-checkbox>
            <veui-button ui="primary"
                v-if="relatedIssueType === 'official'
                    && canOperateOfficial"
                class="f-topic-official-more-issue-btn"
                style="vertical-align: bottom"
                @click="openSetIssueWindow"
                :disabled="isAuditPending || isCheckedNotRelatedIssue">
                设置关联
            </veui-button>
            <veui-button ui="primary"
                v-if="relatedIssueType === 'topic'"
                class="f-topic-official-more-issue-btn"
                style="vertical-align: bottom"
                @click="openSetIssueWindow"
                :disabled="isAuditPending">
                设置关联
            </veui-button>
        </div>

        <!-- 设置关联列表弹窗 -->
        <related-issue-box
            v-if="isSetRelatedIssue"
            :confirm="isSetRelatedIssue"
            :issueType="relatedIssueType"
            :selectedIssueLists="relatedIssueLists"
            :maxlistheight="maxIssueListHeight"
            @setSelectIssue="setSelectIssue"
            @cancel="cancel"
            @ischange="isSelectedChangeInfo"
            @setreply="setReply">
        </related-issue-box>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
import {mapState, mapGetters} from 'vuex';
import MiniStep from './MiniStep.vue';
import RelatedIssueBox from './RelatedIssueBox.vue';
import {Button, Checkbox} from 'veui';
import toast from 'veui/managers/toast';
import {notAllowScroll, allowScroll} from '@/utils/decorate/scroll';

export default {
    props: {
        relatedIssueType: String
    },
    components: {
        'mini-step': MiniStep,
        'related-issue-box': RelatedIssueBox,
        'veui-button': Button,
        'veui-checkbox': Checkbox
    },
    computed: {
        ...mapState({
            OfficialBoardLabel: state => state.topicContent.OfficialBoardLabel,
            officialinfo: state => state.topicContent.topicData.ext.qaOfficialInfo,
            listData: state => state.list.listData,
            topicData: state => state.topicContent.topicData,
            isCheckedNotRelatedIssue: state => state.topicContent.isCheckedNotRelatedIssue,
            showTips: state => state.topicContent.showTips
        }),
        ...mapGetters([
            'canOperateOfficial',
            'isAuditPending'
        ]),
        issuelist: {
            get() {
                return this.relatedIssueType === 'official'
                    ? this.officialinfo.issueList
                    : this.topicData.issueList;
            }
        }
    },
    data() {
        return {
            isShowMoreIssue: false,
            checkedNotRelatedIssue: false,
            isSetRelatedIssue: false,
            relatedIssueLists: [],
            maxIssueListHeight: 220
        };
    },
    mounted() {
        if (this.relatedIssueType === 'official') {
            this.initState();
        }
    },
    methods: {
        initState() {
            if (this.officialinfo.questionCategory === 1
                    && (this.officialinfo.questionType === 1
                        || this.officialinfo.questionType === 2)
                    && this.officialinfo.issueList.length === 0
                    && this.officialinfo.answerContent.length) {
                this.checkedNotRelatedIssue = true;
                this.$store.commit('setCheckedState', true);
            }
        },
        toggleShowMoreIssue() {
            this.isShowMoreIssue = !this.isShowMoreIssue;
        },
        toggleCheck() {
            if (this.checkedNotRelatedIssue) {
                // 打开确认是否不设置issue弹窗
                this.$emit('openwindow', 'notSetRelatedIssue');
            }
            else {
                this.$store.commit('setCheckedState', false);
            }
        },
        openSetIssueWindow() {
            notAllowScroll();
            this.isSetRelatedIssue = true;
            this.relatedIssueLists = [...this.issuelist];
        },
        setSelectIssue(selected, selectedItem, selectedItems) {
            // 不允许关联超过10条
            if (this.relatedIssueLists.length >= this.showTips.maxRelatedIssue && selected) {
                toast.warn(this.showTips.moreRelatedIssue);
                return;
            }

            const index = this.relatedIssueLists.findIndex(item => item.issueId === selectedItem.issueId);
            if (selected && index < 0) {
                this.relatedIssueLists.push(selectedItem);
                return;
            }
            if (!selected && index >= 0) {
                this.relatedIssueLists.splice(
                    this.relatedIssueLists.findIndex(
                        item => item.issueId === selectedItem.issueId
                    ),
                    1
                );
            }
        },
        // 变更已选中项的信息
        isSelectedChangeInfo() {
            if (Object.keys(this.listData).length) {
                const list = this.listData.topicList;
                list.map(item => {
                    const listId = item.issueId;
                    const listItem = item;

                    for (let item of this.relatedIssueLists) {
                        if (item.issueId === listId) {
                            if (item.title !== listItem.title) {
                                item.title = listItem.title;
                            }
                            if (item.process !== listItem.process) {
                                item.process = listItem.process;
                            }
                            break;
                        }
                    }
                });
            }
        },
        cancel() {
            this.isSetRelatedIssue = false;
            allowScroll();
        },
        setReply() {
            if (this.relatedIssueType === 'official') {
                this.$emit('resetreply');
            }
        },
        cancelNotRelated() {
            this.checkedNotRelatedIssue = false;
            this.$store.commit('setCheckedState', false);
        }
    }
};
</script>
